import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F13.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame13() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);

    if (isLoading === true) {
        return (<div className="F12_image"></div>)
    } else {
        return (
            <div className="F13_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F13_entryBox">
                    <div className="F13_paragraph">
                        {language === 'english' ?
                            <p className="F13_paragraphEnglish">Another thing which is disturbing Saira is when it had happened to her best friend Maria she had missed school for a whole week as if she was sick. Saira’s exams are approaching, and she fears of missing her exams.</p>
                            :
                            <p className="F13_paragraphUrdu">ایک اور بات جو کہ سائرا کو بہت پریشان کر رہی ہے کہ جب اس کی سہیلی ماریہ کو ماہواری ہوئی تو وہ پورا ہفتہ سکول سے غیر حاضر رہی جیسے کہ ماہواری کوئی بیماری ہو۔ سائرا کے امتحانات قریب ہیں اور وہ سکول سے غیر حاضر نہیں رہنا چاہتی۔</p>
                        }
                    </div>

                    <div className="F13_timeline">
                        <div className='F13_timelineBar'>
                            <div className='F13_timelineFill'></div>
                            <span className='F13_timelineText'>10/16</span>
                        </div>
                    </div>

                    <div className="F13_nextFrames">
                        <div className="F13_nextFrame1"></div>
                        <div className="F13_nextFrame2"></div>
                        <div className="F13_nextFrame3"></div>
                    </div>

                    <div className='F13_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(10)) }} className='F13_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame13;